var _circle, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardCaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1479FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1017_14515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1017_14515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.75C18.875 17.75 18.3438 17.5312 17.9062 17.0938C17.4688 16.6562 17.25 16.125 17.25 15.5C17.25 14.875 17.4688 14.3438 17.9062 13.9062C18.3438 13.4688 18.875 13.25 19.5 13.25C20.125 13.25 20.6562 13.4688 21.0938 13.9062C21.5313 14.3438 21.75 14.875 21.75 15.5C21.75 16.125 21.5313 16.6562 21.0938 17.0938C20.6562 17.5312 20.125 17.75 19.5 17.75ZM19.5 16.25C19.7125 16.25 19.8906 16.1781 20.0344 16.0344C20.1781 15.8906 20.25 15.7125 20.25 15.5C20.25 15.2875 20.1781 15.1094 20.0344 14.9656C19.8906 14.8219 19.7125 14.75 19.5 14.75C19.2875 14.75 19.1094 14.8219 18.9656 14.9656C18.8219 15.1094 18.75 15.2875 18.75 15.5C18.75 15.7125 18.8219 15.8906 18.9656 16.0344C19.1094 16.1781 19.2875 16.25 19.5 16.25ZM15 23V20.825C15 20.5625 15.0625 20.3156 15.1875 20.0844C15.3125 19.8531 15.4875 19.6688 15.7125 19.5312C16.1125 19.2938 16.5344 19.0969 16.9781 18.9406C17.4219 18.7844 17.875 18.6688 18.3375 18.5938L19.5 20L20.6625 18.5938C21.125 18.6688 21.575 18.7844 22.0125 18.9406C22.45 19.0969 22.8688 19.2938 23.2688 19.5312C23.4938 19.6688 23.6719 19.8531 23.8031 20.0844C23.9344 20.3156 24 20.5625 24 20.825V23H15ZM16.4813 21.5H18.7875L17.775 20.2625C17.55 20.325 17.3313 20.4063 17.1188 20.5063C16.9063 20.6063 16.6938 20.7125 16.4813 20.825V21.5ZM20.2125 21.5H22.5V20.825C22.3 20.7 22.0938 20.5906 21.8813 20.4969C21.6688 20.4031 21.45 20.325 21.225 20.2625L20.2125 21.5ZM10.5 21.5C10.0875 21.5 9.73438 21.3531 9.44063 21.0594C9.14687 20.7656 9 20.4125 9 20V9.5C9 9.0875 9.14687 8.73438 9.44063 8.44063C9.73438 8.14687 10.0875 8 10.5 8H21C21.4125 8 21.7656 8.14687 22.0594 8.44063C22.3531 8.73438 22.5 9.0875 22.5 9.5V13.25C22.3 13 22.0813 12.7625 21.8438 12.5375C21.6063 12.3125 21.325 12.1625 21 12.0875V9.5H10.5V20H13.6125C13.575 20.1375 13.5469 20.275 13.5281 20.4125C13.5094 20.55 13.5 20.6875 13.5 20.825V21.5H10.5ZM12 12.5H17.25C17.575 12.25 17.9313 12.0625 18.3188 11.9375C18.7063 11.8125 19.1 11.75 19.5 11.75V11H12V12.5ZM12 15.5H15.75C15.75 15.2375 15.7781 14.9813 15.8344 14.7313C15.8906 14.4813 15.9688 14.2375 16.0688 14H12V15.5ZM12 18.5H14.5875C14.725 18.3875 14.8719 18.2875 15.0281 18.2C15.1844 18.1125 15.3438 18.0312 15.5063 17.9563V17H12V18.5ZM10.5 20V9.5V12.0688V11.75V20Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCaseIcon);
export default __webpack_public_path__ + "static/media/dashboard-case-icon.0eca30d55f5f563387c61bf891583f86.svg";
export { ForwardRef as ReactComponent };